import { jsxs as n, jsx as r } from "react/jsx-runtime";
import * as a from "react";
import { DayPicker as L } from "react-day-picker";
import { format as M } from "date-fns";
import { X as _, Calendar as O } from "lucide-react";
import { cn as d } from "../../../lib/utils.js";
import { motion as f, AnimatePresence as k } from "framer-motion";
/* empty css                                                                                                           */
const R = a.forwardRef(({ label: h, helperText: b, error: c, value: w, onChange: o, placeholder: N = "Select a date", disabled: p = !1, className: $, minDate: v, maxDate: x }, E) => {
  const [l, m] = a.useState(!1), [i, g] = a.useState(w), u = a.useRef(null), [e, P] = a.useState(!1);
  a.useEffect(() => {
    const t = () => {
      const z = document.documentElement.classList.contains("dark") || document.body.classList.contains("dark") || window.matchMedia("(prefers-color-scheme: dark)").matches;
      P(z);
    };
    t();
    const s = new MutationObserver(t);
    s.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["class"]
    }), s.observe(document.body, {
      attributes: !0,
      attributeFilter: ["class"]
    });
    const y = window.matchMedia("(prefers-color-scheme: dark)");
    return y.addEventListener("change", t), () => {
      s.disconnect(), y.removeEventListener("change", t);
    };
  }, []), a.useEffect(() => {
    const t = (s) => {
      u.current && !u.current.contains(s.target) && m(!1);
    };
    return l && document.addEventListener("mousedown", t), () => {
      document.removeEventListener("mousedown", t);
    };
  }, [l]);
  const D = (t) => {
    g(t), o == null || o(t), m(!1);
  }, S = (t) => {
    t.stopPropagation(), g(void 0), o == null || o(void 0);
  };
  return n("div", { ref: E, className: d("w-full space-y-2 relative group", $), children: [h && r(f.label, { initial: { opacity: 0, y: -4 }, animate: { opacity: 1, y: 0 }, className: "block text-xs font-medium text-text-secondary", children: h }), n("div", { ref: u, className: "relative", children: [n("button", { type: "button", onClick: () => !p && m(!l), disabled: p, className: d("w-full flex items-center justify-between gap-2 rounded-2xl border px-5 py-3.5 text-sm text-left", "bg-surface border-border-color", "transition-all duration-500 ease-luxury shadow-subtle group-hover:shadow-luxury", "focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-lpr-teal/5 focus-visible:border-lpr-teal", "dark:focus-visible:ring-lpr-gold/10 dark:focus-visible:border-lpr-gold", "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-bg-muted", c && "border-lpr-red focus-visible:ring-lpr-red/10", l && "border-lpr-teal dark:border-lpr-gold shadow-luxury"), children: [r("span", { className: d("font-medium tracking-tight truncate", i ? "text-text-primary" : "text-text-secondary/40"), children: i ? M(i, "PPP") : N }), n("div", { className: "flex items-center gap-1", children: [i && !p && r(_, { className: "h-4 w-4 text-text-secondary/40 hover:text-lpr-red hover:opacity-100 transition-all active:scale-90", onClick: S }), r(O, { className: d("h-4 w-4 transition-colors duration-500", l ? "text-lpr-teal dark:text-lpr-gold" : "text-lpr-gold dark:text-lpr-neutral") })] })] }), r(k, { children: l && n(f.div, { initial: { opacity: 0, y: 10, scale: 0.95 }, animate: { opacity: 1, y: 0, scale: 1 }, exit: { opacity: 0, y: 10, scale: 0.95 }, transition: { type: "spring", stiffness: 300, damping: 30 }, className: "absolute z-50 mt-4 bg-surface rounded-2xl border border-border-color shadow-premium p-6 overflow-hidden", children: [r("style", { children: `
                  .rdp-root {
                    --rdp-cell-size: 44px;
                    --rdp-accent-color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"};
                    --rdp-accent-background-color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"};
                    margin: 0;
                    font-family: inherit;
                    color: var(--text-primary);
                  }
                  .rdp-caption_label {
                    font-size: 10px !important;
                    font-weight: 800 !important;
                    text-transform: uppercase !important;
                    letter-spacing: 0.15em !important;
                    color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"} !important;
                  }
                  .rdp-nav {
                    color: hsl(var(--lpr-gold)) !important;
                  }
                  .rdp-nav_button {
                    border-radius: 10px !important;
                    transition: all 0.3s !important;
                  }
                  .rdp-nav_button:hover {
                    background-color: hsla(var(--lpr-gold), ${e ? "0.2" : "0.1"}) !important;
                  }
                  .rdp-head_cell {
                    font-size: 9px !important;
                    font-weight: 800 !important;
                    text-transform: uppercase !important;
                    letter-spacing: 0.1em !important;
                    color: ${e ? "var(--text-secondary)" : "rgba(0,0,0,0.3)"} !important;
                    opacity: ${e ? "0.5" : "1"};
                  }
                  .rdp-day {
                    border-radius: 12px !important;
                    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
                    font-weight: 600 !important;
                    font-size: 13px !important;
                    color: var(--text-primary);
                  }
                  .rdp-day:hover:not(.rdp-selected) {
                    background-color: ${e ? "hsla(var(--lpr-gold), 0.15)" : "hsla(var(--lpr-teal), 0.05)"} !important;
                    scale: 1.1;
                    color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"} !important;
                  }
                  .rdp-selected {
                    background-color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"} !important;
                    color: ${e ? "hsl(var(--lpr-charcoal))" : "white"} !important;
                    box-shadow: 0 8px 20px -5px ${e ? "hsla(var(--lpr-gold), 0.4)" : "hsla(var(--lpr-teal), 0.4)"} !important;
                    scale: 1.05;
                  }
                  .rdp-day_today {
                    color: ${e ? "hsl(var(--lpr-gold))" : "hsl(var(--lpr-teal))"} !important;
                    font-weight: 900 !important;
                    text-decoration: underline underline-offset-4 !important;
                  }
                  .rdp-disabled {
                    opacity: 0.3;
                    color: var(--text-secondary) !important;
                  }
                ` }), r(L, { mode: "single", selected: i, onSelect: D, disabled: v && x ? { before: v, after: x } : void 0 }), r("div", { className: "absolute top-0 right-0 w-32 h-32 bg-lpr-gold/5 dark:bg-lpr-gold/10 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" })] }) })] }), r(k, { mode: "wait", children: (c || b) && r(f.p, { initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: "auto" }, exit: { opacity: 0, height: 0 }, className: d("text-xs font-medium leading-relaxed italic px-1", c ? "text-lpr-red" : "text-text-secondary/60"), children: c || b }) })] });
});
R.displayName = "DatePicker";
export {
  R as DatePicker
};
//# sourceMappingURL=DatePicker.js.map
